import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

import Logo from "./logo_iumv.png";

// Estilos
const styles = StyleSheet.create({
  page: {
    width: 300, // 400px * 0.75
    height: 450, // 600px * 0.75
    padding: 30,
    fontSize: 10,
    fontFamily: "Helvetica",
  },
  logo: {
    width: 60,
    height: 60,
    marginBottom: 10,
    alignSelf: "center",
  },
  header: {
    textAlign: "center",
    marginBottom: 10,
  },
  section: {
    marginBottom: 6,
  },
  label: {
    fontWeight: "bold",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  divider: {
    borderBottom: "1 solid #ccc",
    marginVertical: 6,
  },
});

// Componente principal
const PDFTicket = ({ item }) => {
  return (
    <Document>
      <Page size={{ width: 300, height: 450 }} style={styles.page}>
        <Image src={Logo} style={styles.logo} />

        <View style={styles.header}>
          <Text>Comprobante de Pago</Text>
          <Text>{item.franchise_name}</Text>
          <Text>{item.university_name}</Text>
        </View>

        <View style={styles.divider} />

        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.label}>Folio:</Text>
            <Text>{item.invoice}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Monto:</Text>
            <Text>${parseFloat(item.amount).toFixed(2)}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Periodo:</Text>
            <Text>{item.period}</Text>
          </View>
        </View>

        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.label}>Método:</Text>
            <Text>{item.method_payment}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Fecha Transferencia:</Text>
            <Text>{item.transfer_date}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Fecha Registro:</Text>
            <Text>{item.date_payment.split(" ")[0]}</Text>
          </View>
        </View>

        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.label}>Estado:</Text>
            <Text>{item.status_description}</Text>
          </View>
        </View>

        <View style={styles.divider} />

        <Text style={{ textAlign: "center", marginTop: 10 }}>
          Gracias por su pago
        </Text>
      </Page>
    </Document>
  );
};

export default PDFTicket;
